import { render, staticRenderFns } from "./ownerContract.vue?vue&type=template&id=8ee725d8&scoped=true"
import script from "./ownerContract.vue?vue&type=script&lang=js"
export * from "./ownerContract.vue?vue&type=script&lang=js"
import style0 from "./ownerContract.vue?vue&type=style&index=0&id=8ee725d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee725d8",
  null
  
)

export default component.exports